import type { WregTrackId } from '../wregScenarios';

type WregConditionId =
  | 'htn'
  | 'dys'
  | 'dm'
  | 'pre'
  | 'ckd'
  | 'ascvd'
  | 'obes'
  | 'dep'
  | 'anx';

type WregSubConditionId = 'dm2' | 'ckd' | 'ascvd' | 'htn' | 'dys' | 'obes' | 'pre' | 'dep' | 'anx';

const WREG_CONDITIONS: WregConditionId[] = [
  'htn',
  'dys',
  'dm',
  'pre',
  'ckd',
  'ascvd',
  'obes',
  'dep',
  'anx',
];

const WREG_TRACK_CONDITIONS: Record<WregTrackId, WregConditionId[]> = {
  ckm: ['htn', 'dys', 'dm', 'pre', 'ckd', 'ascvd', 'obes'],
  eckm: ['htn', 'dys', 'dm', 'pre', 'ascvd', 'obes'],
  bh: ['dep', 'anx'],
};

const WREG_TRACK_SUBCONDITIONS: Record<WregTrackId, WregSubConditionId[]> = {
  ckm: ['dm2', 'ckd', 'ascvd'],
  eckm: ['htn', 'dys', 'obes', 'pre'],
  bh: ['dep', 'anx'],
};

export { WREG_CONDITIONS, WREG_TRACK_CONDITIONS, WREG_TRACK_SUBCONDITIONS };
export type { WregConditionId, WregSubConditionId };
